<template>
    <div class="history-wrap">
        <div class="history" v-for="(yearData, index) in historyData" :key="`historyYear${yearData.year}`">
            <div class="history-year">{{yearData.year}}</div>
            <div class="history-content-wrap">
                <div class="history-content" v-for="(data, index) in yearData.yearData">
                    <div class="history-month">{{data.month}}월</div>
                    <div class="history-name" v-html="data.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import util from "@/mixins/util";

    export default {
        name: "HistoryComponent",
        mixins: [],
        components: {
        },
        inject: [],
        provide() {
            return{

            }
        },
        props: {
        },
        data() {
            return{
                historyData: [],
            }
        },
        beforeRouterEnter() {},
        created() {
            this.getHistory();
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            getHistory() {
                let params = {
                    ip: 0,
                    obc: 'ch_date',
                    obs: 'desc',
                }
                try {
                    this.$api.$history.getHistory(params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1) {
                            return;
                        }
                        let list = res.List;
                        util.Array.each(list, (obj, index, arr) => {
                            let year = obj.ch_date.split('-')[0]
                            if(this.historyData.length === 0 || this.historyData.findIndex(history => history.year === year) < 0) {
                                let defaultData = {
                                    year: year,
                                    yearData: [],
                                };
                                this.historyData.push(defaultData);
                                // yearIndex = 0;
                            }
                            let month = obj.ch_date.split('-')[1];
                            let dataObj = {month: month, content: this.parsingBr(obj.ch_content)};
                            let yearIndex = this.historyData.findIndex(history => history.year === year)
                            this.historyData[yearIndex].yearData.push(dataObj);

                        })
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            parsingBr(content) {
                return util.isEmpty(content) ? '' : content.replace(/\n/g, "<br />");
            },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
